<template>
  <t-dialog
    v-bind="$attrs"
    v-on="$listeners"
    attach="body"
    :closeBtn="false"
    :destroyOnClose="true"
    :closeOnOverlayClick="false">
    <template #header>
      <slot name="custome-header">
        <div class="header">{{ title }}</div>
      </slot>
    </template>
    <template #body>
      <slot />
    </template>
    <template #footer>
      <slot name="customer-footer">
        <div class="footer">
          <div class="left" @click="leftClick">{{ customerFooter.leftText }}</div>
          <div class="right" @click="rightClick">{{ customerFooter.rightText }}</div>
        </div>
      </slot>
    </template>
  </t-dialog>
</template>
<script>
import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: i18n_t('标题'),
    },
    customerFooter: {
      type: Object,
      default: () => ({
        leftText: i18n_t('取消'),
        rightText: i18n_t('确认'),
      }),
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const mehotds = {
      leftClick() {
        context.emit('onCancel');
      },
      rightClick() {
        context.emit('onConfirm');
      },
    };
    return {
      ...mehotds,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/renderer/assets/variable.scss';

::v-deep .t-dialog__header {
  padding: 0;
}
::v-deep .t-dialog--default {
  padding: 0;
}
::v-deep .t-dialog__footer {
  padding: 0;
}
::v-deep .t-dialog {
  width: 90%;
  border: none;
  overflow: hidden;
}
::v-deep .t-dialog__body {
  padding: 0;
}

.header {
  text-align: center;
  width: 100%;
  line-height: 56px;
  height: 56px;
}

.footer {
  width: 100%;
  display: flex;
  width: 100%;
  height: 56px;
  border-top: 0.5px solid $gray-color-6;
  box-sizing: border-box;

  .left {
    border-right: 0.5px solid $gray-color-6;
  }

  .right {
    color: $brand-color-1;
  }

  .left,
  .right {
    font-size: 16px;
    flex: 1;
    text-align: center;
    line-height: 56px;
    height: 56px;

    &:active {
      background-color: $gray-color-1;
    }
  }
}
</style>
